import React from 'react'
import { FoodMealDayComponent } from './FoodMealDayComponent'
import { DeleteOutlined, DoubleRightOutlined, EditOutlined, PlusOutlined, ToolOutlined } from '@ant-design/icons';
import { Button, Col, Row } from 'antd';

export const FoodMealWeekComponent = ({
    setLoading,
    showMessage,
    foodListPeriodId,
    onBackClick,
}) => {
    return (
        <>
            <Row className='sectionTitle' style={{borderBottom:'2px solid #cdcdcd',paddingBottom:'10px'}}>
                <Col xs={6} sm={6} md={6} lg={5} xl={5} style={{ textAlign: "right" }} >
                    <Button onClick={() => onBackClick()}>
                        <DoubleRightOutlined />
                        بازگشت
                    </Button>
                </Col>
                <Col xs={10} sm={10} md={10} lg={14} xl={14}>
                    <h2 >
                        برنامه هفتگی غذا
                    </h2>
                </Col>
                <Col xs={10} sm={10} md={8} lg={5} xl={5} style={{ textAlign: "left" }}>
              
                </Col>

            </Row>
            <FoodMealDayComponent
                setLoading={setLoading}
                showMessage={showMessage}
                foodListPeriodId={foodListPeriodId}
                dayId={6}
                dayTitle={"شنبه"}
            />

            <FoodMealDayComponent
                setLoading={setLoading}
                showMessage={showMessage}
                foodListPeriodId={foodListPeriodId}
                dayId={0}
                dayTitle={"یکشنبه"}
            />

            <FoodMealDayComponent
                setLoading={setLoading}
                showMessage={showMessage}
                foodListPeriodId={foodListPeriodId}
                dayId={1}
                dayTitle={"دوشنبه"}

            />

            <FoodMealDayComponent
                setLoading={setLoading}
                showMessage={showMessage}
                foodListPeriodId={foodListPeriodId}
                dayId={2}
                dayTitle={"سه شنبه"}
            />

            <FoodMealDayComponent
                setLoading={setLoading}
                showMessage={showMessage}
                foodListPeriodId={foodListPeriodId}
                dayId={3}
                dayTitle={"چهارشنبه"}

            />

            <FoodMealDayComponent
                setLoading={setLoading}
                showMessage={showMessage}
                foodListPeriodId={foodListPeriodId}
                dayId={4}
                dayTitle={"پنجشنبه"}

            />

            <FoodMealDayComponent
                setLoading={setLoading}
                showMessage={showMessage}
                foodListPeriodId={foodListPeriodId}
                dayId={5}
                dayTitle={"جمعه"}
            />

        </>
    )
}

